import type { IsoDate } from "../../../common/src";

export interface DaySelection {
  startDate?: IsoDate;
  endDate?: IsoDate;
}

/**
 * Calendar click behaviour: the first click picks a start day, the second an end day.
 * Clicking before the current start restarts the selection there; a third click starts over.
 */
export const nextSelection = (
  current: DaySelection,
  clicked: IsoDate
): DaySelection => {
  const { startDate, endDate } = current;
  if (!startDate || endDate || clicked < startDate) {
    return { startDate: clicked };
  }
  return { startDate, endDate: clicked };
};

export const isSelected = (
  { startDate, endDate }: DaySelection,
  date: IsoDate
): boolean =>
  startDate !== undefined &&
  date >= startDate &&
  date <= (endDate ?? startDate);
